<template>
  <span class="text-sm font-medium text-foreground">
    <label :for="props.for ?? fieldContext?.inputId">
      <slot />

      <template v-if="required">
        <span class="text-red-500" aria-hidden="true">*</span>
        <span class="sr-only">(required)</span>
      </template>
    </label>

    <InfoPopover v-if="$slots.info">
      <slot name="info" />
    </InfoPopover>
  </span>
</template>

<script setup lang="ts">
import { injectFieldContext } from "./context";
import InfoPopover from "./internal/InfoPopover.vue";

const props = defineProps<{
  for?: string;
  required?: boolean;
}>();

const fieldContext = injectFieldContext(null);
</script>
